const HospitalManager = (function() {
  // Private state
  let contactId = null;
  let selectedHospitals = [];
  let isInitialized = false;
  let currentSearchController = null;
  let searchTimeout = null;
  let removeModal = null;
  let hospitalToRemove = null;
  
  // Initialize with data from server response
  function init(contact, hospitals = []) {
    if (isInitialized) return;

    contactId = contact;
    
    // Set initial hospitals from server data
    selectedHospitals = hospitals.map(hospital => ({
      id: hospital.id || generateTempId(), // Generate temp ID if not provided
      name: hospital.name,
      street: hospital.street,
      city: hospital.city,
      state: hospital.state,
      zipCode: hospital.zip || hospital.zipCode
    }));
    
    // Render the initial UI
    render();
    initializeRemoveModal();

    // Check the not-affiliated-with-hospital checkbox on load
    if (selectedHospitals.length == 0) {
      const notAffiliatedCheckbox = document.getElementById('not-affiliated-with-hospital');
      if (notAffiliatedCheckbox && notAffiliatedCheckbox.checked) {
        // Hide the columns if checkbox is checked
        const hospitalSearchColumn = document.querySelector('#hospital-search-column');
        const hospitalOtherCol = document.querySelector('#hospital-other-col');
        const affiliatedHospitalsCol = document.querySelector('#affiliated-hospitals-col');
        
        if (hospitalSearchColumn) hospitalSearchColumn.classList.add("d-none");
        if (affiliatedHospitalsCol) affiliatedHospitalsCol.classList.add("d-none");
        if (hospitalOtherCol) hospitalOtherCol.classList.add("d-none");
      }
    }

    isInitialized = true;
  }
  
  // Generate temporary ID for hospitals without IDs
  function generateTempId() {
    return 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // Initialize modal (call this in your init function or when DOM is ready)
  function initializeRemoveModal() {
    const modalElement = document.getElementById('remove-hospital-modal');
    if (modalElement) {
      removeModal = new bootstrap.Modal(modalElement);
      
      // Set up the confirm button handler
      const confirmBtn = document.getElementById('confirm-remove-hospital');
      if (confirmBtn) {
        confirmBtn.addEventListener('click', confirmRemoveHospital);
      }
    }
  }
  
  // Render the hospital list based on current state
  function render() {
    const container = document.querySelector('#affiliated-hospitals-container');
    if (!container) {
      console.error('Container #affiliated-hospitals-container not found');
      return;
    }

    // Hide/show the not-affiliated-with-hospital element based on hospital count
    const notAffiliatedRow = document.getElementById('not-affiliated-with-hospital-row');
    if (notAffiliatedRow) {
      if (selectedHospitals.length > 0) {
        notAffiliatedRow.style.display = 'none';
      } else {
        notAffiliatedRow.style.display = ''; // Reset to default display
      }
    }
    
    container.innerHTML = '';
    
    if (selectedHospitals.length === 0) {
      const emptyMessage = document.createElement('p');
      emptyMessage.className = 'text-muted';
      emptyMessage.textContent = 'None selected.';
      container.appendChild(emptyMessage);
    } else {
      const listGroup = document.createElement('div');
      listGroup.id = 'affiliated-hospitals';
      listGroup.className = 'list-group mb-3';
      
      selectedHospitals.forEach(hospital => {
        const item = createHospitalListItem(hospital);
        listGroup.appendChild(item);
      });
      
      container.appendChild(listGroup);
      
      // Initialize Bootstrap popovers if using Option 3
      if (typeof bootstrap !== 'undefined') {
        const popoverTriggerList = container.querySelectorAll('[data-bs-toggle="popover"]');
        [...popoverTriggerList].map(popoverTriggerEl => {
          return new bootstrap.Popover(popoverTriggerEl, {
            customClass: 'popover-large',
            container: 'body'
          });
        });
      }
    }
    
    updateHiddenField();
  }
  
  // Create a list item element for a hospital
  function createHospitalListItem(hospital) {
    const div = document.createElement('div');
    div.setAttribute('data-hospital-id', hospital.id);
    div.className = 'list-group-item list-group-item-action d-flex align-items-md-center justify-content-between p-2 flex-column flex-md-row gap-2';
    
    // Hospital name with badge
    const nameContainer = document.createElement('div');
    nameContainer.className = 'd-flex align-items-start align-items-md-center flex-grow-1 flex-column flex-md-row gap-2';
    
    const nameSpan = document.createElement('span');
    nameSpan.textContent = hospital.name;
    
    // Location badge
    const locationBadge = document.createElement('span');
    locationBadge.className = 'badge bg-light text-secondary';
    locationBadge.style.fontSize = '0.75rem';
    locationBadge.style.cursor = 'pointer';
    locationBadge.innerHTML = `<i class="bi bi-geo-alt"></i> ${hospital.city}, ${hospital.state}`;
    
    // Build full address for popover
    let fullAddress = hospital.name + '<br>';
    if (hospital.street) {
      fullAddress += hospital.street + '<br>';
    }
    fullAddress += `${hospital.city}, ${hospital.state}`;
    if (hospital.zipCode) {
      fullAddress += ' ' + hospital.zipCode;
    }
    
    // Add popover attributes
    locationBadge.setAttribute('data-bs-toggle', 'popover');
    locationBadge.setAttribute('data-bs-trigger', 'hover focus');
    locationBadge.setAttribute('data-bs-placement', 'top');
    locationBadge.setAttribute('data-bs-html', 'true');
    locationBadge.setAttribute('data-bs-content', fullAddress);
    locationBadge.setAttribute('title', 'Full Address');
    
    nameContainer.appendChild(nameSpan);
    nameContainer.appendChild(locationBadge);
    
    // Action buttons
    const btnGroup = document.createElement('div');
    btnGroup.className = 'btn-group btn-group-sm';
    
    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'btn btn-small btn-danger';
    removeBtn.innerHTML = 'Remove';
    removeBtn.title = 'Remove';
    removeBtn.onclick = () => remove(hospital.id);
    
    btnGroup.appendChild(removeBtn);
    
    div.appendChild(nameContainer);
    div.appendChild(btnGroup);
    
    return div;
  }
  
  // Update hidden form field with current hospital IDs
  function updateHiddenField() {
    let hiddenField = document.querySelector('#selected-hospitals-json');
    if (!hiddenField) {
      hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.id = 'selected-hospitals-json';
      hiddenField.name = 'selected_hospitals';
      const form = document.querySelector('#update-customer');
      if (form) form.appendChild(hiddenField);
    }
    hiddenField.value = JSON.stringify(selectedHospitals);
  }

  // Add a hospital from a DOM element (used by search results)
  async function selectHospital(buttonElement) {
    // Store original button state
    const originalText = buttonElement.textContent;
    const originalDisabled = buttonElement.disabled;
    
    // Set loading state
    buttonElement.disabled = true;
    buttonElement.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Adding...';
    
    const hospitalData = {
      id: buttonElement.getAttribute("data-hospital-id"),
      name: buttonElement.getAttribute("data-name"),
      street: buttonElement.getAttribute("data-street"),
      city: buttonElement.getAttribute("data-city"),
      state: buttonElement.getAttribute("data-state"),
      zipCode: buttonElement.getAttribute("data-zip")
    };
    
    const success = await add(hospitalData);
    
    if (success) {
      // Update button to show "Added" state
      buttonElement.textContent = 'Added';
      buttonElement.disabled = true;
      buttonElement.classList.remove('btn-primary');
      buttonElement.classList.add('btn-secondary');
    } else {
      // Restore original state if failed
      buttonElement.textContent = originalText;
      buttonElement.disabled = originalDisabled;
    }
    
    return success;
  }
  
  // Add a hospital
  async function add(hospitalData) {
    // Check if already exists
    if (selectedHospitals.some(h => 
      h.name === hospitalData.name && 
      h.city === hospitalData.city && 
      h.state === hospitalData.state
    )) {
      console.log('Hospital already selected');
      showNotification('This hospital is already in your list', 'warning');
      return false;
    }
    
    try {
      const formData = new FormData();
      formData.append('contact-id', contactId);
      formData.append('hospital-id', hospitalData.id);
      formData.append('hospital-name', hospitalData.name);
      
      const baseUrl = window.nbpasAjaxUrl || 'https://app.nbpas.org';
      const response = await fetch(`${baseUrl}/ajax/addAffiliatedHospital.php`, {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Failed to save hospital');
      
      await response.json();
      
      // Add to state and re-render
      selectedHospitals.push(hospitalData);
      render();
      
      // Update all buttons with this hospital ID to show "Added" state
      updateSearchResultButtons(hospitalData.id);
      
      // Show success message
      showNotification('Hospital added successfully', 'success');
      
      // Scroll to list
      const container = document.querySelector("#affiliated-hospitals-container");
      if (container) {
        container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      
      return true;
      
    } catch (error) {
      console.error('Error adding hospital:', error);
      showNotification('Failed to add hospital. Please try again.', 'danger');
      return false;
    }
  }

  // Function to manually add a hospital from form inputs
  async function addManualHospital() {
    // Get form values
    const nameInput = document.getElementById('hospital-name');
    const streetInput = document.getElementById('hospital-street');
    const cityInput = document.getElementById('hospital-city');
    const stateSelect = document.getElementById('hospital-state');
    const zipInput = document.getElementById('hospital-zip');
    
    // Validate required fields
    if (!nameInput.value.trim() || !cityInput.value.trim() || !stateSelect.value) {
      showNotification('Please fill in all required fields (Name, City, and State)', 'warning');
      
      // Add visual feedback for missing fields
      if (!nameInput.value.trim()) nameInput.classList.add('is-invalid');
      if (!cityInput.value.trim()) cityInput.classList.add('is-invalid');
      if (!stateSelect.value) stateSelect.classList.add('is-invalid');
      
      return false;
    }
    
    // Create hospital data object
    const hospitalData = {
      id: generateTempId(), // Generate a temporary ID for manual entries
      name: nameInput.value.trim(),
      street: streetInput.value.trim(),
      city: cityInput.value.trim(),
      state: stateSelect.value,
      zipCode: zipInput.value.trim()
    };
    
    // Check if this hospital already exists
    if (selectedHospitals.some(h => 
      h.name.toLowerCase() === hospitalData.name.toLowerCase() && 
      h.city.toLowerCase() === hospitalData.city.toLowerCase() && 
      h.state === hospitalData.state
    )) {
      showNotification('This hospital is already in your list', 'warning');
      return false;
    }
    
    // Show loading state on the button
    const addButton = event.target || document.querySelector('#hospital-other-col button.btn-primary');
    const originalText = addButton.innerHTML;
    addButton.disabled = true;
    addButton.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Adding...';
    
    try {
      // Save to backend
      const formData = new FormData();
      formData.append('contact-id', contactId);
      formData.append('hospital-name', hospitalData.name);
      formData.append('hospital-street', hospitalData.street);
      formData.append('hospital-city', hospitalData.city);
      formData.append('hospital-state', hospitalData.state);
      formData.append('hospital-zip', hospitalData.zipCode);
      formData.append('is-manual', 'true'); // Flag to indicate manual entry
      
      const baseUrl = window.nbpasAjaxUrl || 'https://app.nbpas.org';
      const response = await fetch(`${baseUrl}/ajax/addManualHospital.php`, {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Failed to save hospital');
      
      const result = await response.json();
      
      // Update the hospital ID if returned from server
      if (result.hospitalId) {
        hospitalData.id = result.hospitalId;
      }
      
      // Add to state and re-render
      selectedHospitals.push(hospitalData);
      render();
      
      // Clear the form
      clearManualHospitalForm();
      
      // Show success message
      showNotification(`${hospitalData.name} has been added successfully`, 'success');
      
      // Scroll to the list
      const container = document.querySelector("#affiliated-hospitals-container");
      if (container) {
        container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      
      return true;
      
    } catch (error) {
      console.error('Error adding manual hospital:', error);
      showNotification('Failed to add hospital. Please try again.', 'danger');
      return false;
      
    } finally {
      // Restore button state
      addButton.disabled = false;
      addButton.innerHTML = originalText;
    }
  }

  // Function to clear the manual hospital form
  function clearManualHospitalForm() {
    const fields = [
      'hospital-name',
      'hospital-street', 
      'hospital-city',
      'hospital-state',
      'hospital-zip'
    ];
    
    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.value = '';
        field.classList.remove('is-invalid');
      }
    });
  }
  
  // Update search result buttons for a specific hospital
  function updateSearchResultButtons(hospitalId) {
    // Find all buttons with this hospital ID in search results
    const buttons = document.querySelectorAll(`#search-hospital-results button[data-hospital-id="${hospitalId}"]`);
    buttons.forEach(button => {
      button.textContent = 'Added';
      button.disabled = true;
      button.classList.remove('btn-primary');
      button.classList.add('btn-secondary');
    });
  }

  async function searchHospitals() {
    const searchHospitalAddress = document.querySelector("#search-hospital-address");
    const searchHospitalState = document.querySelector("#search-hospital-state");
    const searchHospitalCity = document.querySelector("#search-hospital-city");
    const searchHospitalResults = document.getElementById("search-hospital-results");
    
    if (!searchHospitalAddress || !searchHospitalState || !searchHospitalCity || !searchHospitalResults) {
      console.error('Hospital search elements not found');
      return;
    }
    
    const addressInput = searchHospitalAddress.value.trim();
    const stateInput = searchHospitalState.value.trim();
    const cityInput = searchHospitalCity.value.trim();
    
    // Clear if all inputs are empty
    if (!addressInput && !stateInput && !cityInput) {
      // Cancel any pending request
      if (currentSearchController) {
        currentSearchController.abort();
        currentSearchController = null;
      }
      searchHospitalResults.innerHTML = "";
      return;
    }
    
    // Cancel previous search request if it exists
    if (currentSearchController) {
      currentSearchController.abort();
    }
    
    // Create new AbortController for this request
    currentSearchController = new AbortController();
    
    // Show loading state
    searchHospitalResults.innerHTML = `
      <div class="text-center py-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted mt-2 mb-0">Searching hospitals...</p>
      </div>
    `;
    
    try {
      const selectedHospitalIds = selectedHospitals.map(h => h.id);
      
      const requestData = {
        address_input: addressInput,
        state_input: stateInput,
        city_input: cityInput,
        selected_hospitals: selectedHospitalIds
      };
      
      const baseUrl = window.nbpasAjaxUrl || 'https://app.nbpas.org';
      const response = await fetch(`${baseUrl}/api_endpoints/get_hospital_addresses_v2.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData),
        signal: currentSearchController.signal // Add the abort signal
      });
      
      if (!response.ok) {
        throw new Error(`Search failed: ${response.status}`);
      }
      
      const htmlContent = await response.json();
      
      // Only update results if this request wasn't aborted
      if (!currentSearchController.signal.aborted) {
        searchHospitalResults.innerHTML = htmlContent;
      }
      
    } catch (error) {
      // Check if error is from request being aborted
      if (error.name === 'AbortError') {
        console.log('Search request was cancelled');
        return; // Don't show error for cancelled requests
      }
      
      console.error('Error searching hospitals:', error);
      searchHospitalResults.innerHTML = `
        <div class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          An error occurred while searching. Please try again.
        </div>
      `;
    } finally {
      // Clear the controller reference if this was the latest request
      if (currentSearchController && !currentSearchController.signal.aborted) {
        currentSearchController = null;
      }
    }
  }

  // Debounced search function
  function searchHospitalsDebounced() {
    // Clear any existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Cancel any in-flight request immediately when user types
    if (currentSearchController) {
      currentSearchController.abort();
      currentSearchController = null;
    }
    
    // Set new timeout
    searchTimeout = setTimeout(() => {
      searchHospitals();
    }, 300); // Wait 300ms after user stops typing
  }
  
  // Remove a hospital
  async function remove(hospitalId) {
    const hospital = selectedHospitals.find(h => h.id === hospitalId);
    if (!hospital) return;
    
    // Store the hospital to remove
    hospitalToRemove = hospital;
    
    // Update modal content with hospital details
    const detailsDiv = document.getElementById('hospital-to-remove-details');
    if (detailsDiv) {
      let addressHTML = `<strong>${hospital.name}</strong><br>`;
      if (hospital.street) {
        addressHTML += `${hospital.street}<br>`;
      }
      addressHTML += `${hospital.city}, ${hospital.state}`;
      if (hospital.zipCode) {
        addressHTML += ` ${hospital.zipCode}`;
      }
      detailsDiv.innerHTML = addressHTML;
    }
    
    // Reset button state
    const confirmBtn = document.getElementById('confirm-remove-hospital');
    const spinner = document.getElementById('remove-spinner');
    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-1 d-none" id="remove-spinner"></span>Remove Hospital';
    }
    
    // Show the modal
    if (removeModal) {
      removeModal.show();
    }
  }

  // Function to handle actual removal
  async function confirmRemoveHospital() {
    if (!hospitalToRemove) return;

    // Remove any existing alert at the start
    const modalBody = document.querySelector('#remove-hospital-modal .modal-body');
    const existingAlert = modalBody.querySelector('.alert-danger');
    if (existingAlert) existingAlert.remove();
    
    const confirmBtn = document.getElementById('confirm-remove-hospital');
    const spinner = confirmBtn.querySelector('.spinner-border');
    
    // Show loading state
    confirmBtn.disabled = true;
    spinner.classList.remove('d-none');
    
    try {
      const formData = new FormData();
      formData.append('contact-id', contactId);
      formData.append('hospital-id', hospitalToRemove.id);
      formData.append('hospital-name', hospitalToRemove.name);
      
      const baseUrl = window.nbpasAjaxUrl || 'https://app.nbpas.org';
      const response = await fetch(`${baseUrl}/ajax/removeAffiliatedHospital.php`, {
        method: 'POST',
        body: formData
      });
      
      const result = await response.json();
      
      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Failed to remove hospital');
      }
      
      // Remove from state and re-render
      selectedHospitals = selectedHospitals.filter(h => h.id !== hospitalToRemove.id);
      render();
      
      // Re-enable button in search results if it exists
      const searchButton = document.querySelector(`#search-hospital-results button[data-hospital-id="${hospitalToRemove.id}"]`);
      if (searchButton) {
        searchButton.textContent = 'Add';
        searchButton.disabled = false;
        searchButton.classList.remove('btn-secondary');
        searchButton.classList.add('btn-primary');
      }
      
      // Hide modal
      removeModal.hide();
      
      // Show success notification
      showNotification(`${hospitalToRemove.name} has been removed successfully`, 'success');
      
      // Clear the reference
      hospitalToRemove = null;
      
    } catch (error) {
      console.error('Error removing hospital:', error);
      
      // Hide loading state but keep modal open
      confirmBtn.disabled = false;
      spinner.classList.add('d-none');
      
      // Show error in modal
      const errorAlert = document.createElement('div');
      errorAlert.className = 'alert alert-danger hospital-notification fade show mt-3';
      errorAlert.innerHTML = `
        <strong>Error:</strong> ${error.message || 'Failed to remove hospital. Please try again.'}
      `;
      modalBody.appendChild(errorAlert);
    }
  }
  
  // Show notification
  function showNotification(message, type = 'info') {
    // Remove existing notifications
    const existingAlert = document.querySelector('.hospital-notification');
    if (existingAlert) existingAlert.remove();
    
    const alert = document.createElement('div');
    alert.className = `alert alert-${type} hospital-notification fade show mt-3`;
    alert.textContent = message;
    
    const container = document.querySelector('#hospital-alert');
    if (container) {
      container.appendChild(alert);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        alert.classList.remove('show');
        setTimeout(() => alert.remove(), 150);
      }, 4000);
    }
  }

  // Clear hospital search
  function clearHospitalSearch() {
    // Cancel any pending search
    if (searchTimeout) {
      clearTimeout(searchTimeout);
      searchTimeout = null;
    }
    
    // Cancel any in-flight request
    if (currentSearchController) {
      currentSearchController.abort();
      currentSearchController = null;
    }
    
    // Clear input fields
    const searchFields = [
      "#search-hospital-address",
      "#search-hospital-city", 
      "#search-hospital-state"
    ];
    
    searchFields.forEach(selector => {
      const field = document.querySelector(selector);
      if (field) field.value = '';
    });
    
    // Clear results
    const searchResults = document.querySelector("#search-hospital-results");
    if (searchResults) searchResults.innerHTML = '';
  }

  // Function to populate hospital fields from dropdown selection
  function populateHospitalFields(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    
    if (!selectElement.value) {
      // Clear fields if no hospital selected
      document.getElementById('hospital-name').value = '';
      document.getElementById('hospital-phone').value = '';
      document.getElementById('hospital-street').value = '';
      document.getElementById('hospital-city').value = '';
      document.getElementById('hospital-state').value = '';
      document.getElementById('hospital-zip').value = '';
      return;
    }
    
    // Get data from data attributes
    const hospital = {
      name: selectedOption.getAttribute('data-name') || '',
      phone: selectedOption.getAttribute('data-phone') || '',
      street: selectedOption.getAttribute('data-street') || '',
      city: selectedOption.getAttribute('data-city') || '',
      state: selectedOption.getAttribute('data-state') || '',
      zip: selectedOption.getAttribute('data-zip') || ''
    };
    
    // Populate the fields
    document.getElementById('hospital-name').value = hospital.name;
    document.getElementById('hospital-phone').value = hospital.phone;
    document.getElementById('hospital-street').value = hospital.street;
    document.getElementById('hospital-city').value = hospital.city;
    document.getElementById('hospital-state').value = hospital.state;
    document.getElementById('hospital-zip').value = hospital.zip;
  }

  // Toggle hospital columns visibility based on checkbox state
  function toggleHospitalColumns() {
    const checkbox = document.getElementById('not-affiliated-with-hospital');
    if (!checkbox) return;
    
    const hospitalSearchColumn = document.querySelector('#hospital-search-column');
    const hospitalOtherCol = document.querySelector('#hospital-other-col');
    const affiliatedHospitalsCol = document.querySelector('#affiliated-hospitals-col');
    
    if (checkbox.checked) {
      if (hospitalSearchColumn) hospitalSearchColumn.classList.add("d-none");
      if (affiliatedHospitalsCol) affiliatedHospitalsCol.classList.add("d-none");
      if (hospitalOtherCol) hospitalOtherCol.classList.add("d-none");
    } else {
      if (hospitalSearchColumn) hospitalSearchColumn.classList.remove("d-none");
      if (affiliatedHospitalsCol) affiliatedHospitalsCol.classList.remove("d-none");
      // Note: hospitalOtherCol is not shown when unchecked
    }
  }
  
  // Get current hospitals
  function getHospitals() {
    return [...selectedHospitals]; // Return a copy
  }
  
  // Clear all hospitals (useful for testing)
  function clear() {
    selectedHospitals = [];
    render();
  }
  
  // Public API
  return {
    init,
    selectHospital,
    add,
    addManualHospital,
    remove,
    getHospitals,
    clear,
    render,
    searchHospitals,
    searchHospitalsDebounced,
    clearHospitalSearch,
    clearManualHospitalForm,
    populateHospitalFields,
    toggleHospitalColumns
  };
})();